(function () {
  var TARGET_PATH = '/apps/box-builder/beetles-limited-time-bundle-deals';

  if (window.location.pathname.replace(/\/$/, '') !== TARGET_PATH) {
    return;
  }

  var SELECTORS = {
    currentStepIcon: '[class*="stepBar-module__step_item_icon_current__"]',
    doneStepIcon: '[class*="stepBar-module__step_item_icon_done__"]',
    stepIcon: '[class*="stepBar-module__step_item_icon"]',
    selectedSlot:
      '[class*="productSelected-module__product_selected__"], [class*="productSelected-module__product_selected_empty__"], [class*="cosmetic-module__product_selected__"], [class*="cosmetic-module__product_selected_empty__"], [class*="boxItemMobile-module__summary_content_info"], [class*="boxItem-module__summary_content_info"], [class*="boxProductMobile-module__summary_content_info"], [class*="boxProduct-module__summary_content_info"], [class*="sidebarSummary-module__addOnRow"]',
    emptySlot:
      '[class*="productSelected-module__product_selected_empty__"], [class*="cosmetic-module__product_selected_empty__"]',
    removeButton:
      '[class*="productSelected-module__icon_remove_product"], [class*="cosmetic-module__icon_remove_product"], [class*="summary_btn_edit"], button[aria-label*="remove"], button[aria-label*="delete"], button[title*="remove"], button[title*="delete"]',
    clearButton:
      '[class*="sidebarSummary-module__mobileClear"], [class*="sidebarSummary-module__clear"], button[aria-label*="clear"], button[title*="clear"]',
    stepClickTarget:
      '[class*="stepBar-module__step_item"], [class*="style1Header-module__item"], [class*="style2Header-module__item"]',
    addButton:
      'button, [role="button"], [class*="addToBoxButton-module__button_atc"], [class*="addToBoxButton-module__button_plus"], [class*="productContent-module__add_quantity_product_btn"], [class*="productContent-module__product_button"]',
  };

  var DISABLED_CLASS = 'box-builder-limit-disabled';
  var WARNING_TEXT = 'Only one product can be selected from this step.';
  var mutationTimer = null;
  var tableLocks = [];
  var hasLockState = false;

  function isVisible(element) {
    if (!element || !(element instanceof Element)) {
      return false;
    }

    var rect = element.getBoundingClientRect();
    var style = window.getComputedStyle(element);

    return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden';
  }

  function parseStepNumber(element) {
    var number = parseInt((element && element.textContent ? element.textContent : '').trim(), 10);
    return Number.isFinite(number) ? number : null;
  }

  function getCurrentStepIndex() {
    var currentStepIcon = document.querySelector(SELECTORS.currentStepIcon);
    var currentStepNumber = parseStepNumber(currentStepIcon);

    if (currentStepNumber) {
      return currentStepNumber - 1;
    }

    var completedSteps = Array.from(document.querySelectorAll(SELECTORS.doneStepIcon)).filter(isVisible);
    return completedSteps.length;
  }

  function getStepCount() {
    return Array.from(document.querySelectorAll(SELECTORS.stepIcon)).filter(isVisible).length;
  }

  function getVisibleSelectedSlots() {
    var slots = Array.from(document.querySelectorAll(SELECTORS.selectedSlot))
      .filter(function (slot) {
        return isVisible(slot) && !slot.parentElement.closest(SELECTORS.selectedSlot);
      })
      .sort(function (a, b) {
        var aRect = a.getBoundingClientRect();
        var bRect = b.getBoundingClientRect();

        return aRect.top === bRect.top ? aRect.left - bRect.left : aRect.top - bRect.top;
      });

    return slots;
  }

  function isFilledSlot(slot) {
    if (!slot || slot.matches(SELECTORS.emptySlot)) {
      return false;
    }

    return Boolean(
      slot.querySelector('img') ||
        slot.querySelector('[class*="name_product_selected"], [class*="variant_product_selected"]') ||
        slot.textContent.trim().replace('+', '')
    );
  }

  function getSelectedItemCountFromSummary() {
    var text = document.body && document.body.innerText ? document.body.innerText : '';
    var match = text.match(/\b(\d+)\s+items?\s+in\s+box\b/i);

    return match ? parseInt(match[1], 10) || 0 : 0;
  }

  function syncLocksWithSelectedSlots() {
    var slots = getVisibleSelectedSlots();
    var filledSlots = slots.filter(isFilledSlot);
    var summaryCount = getSelectedItemCountFromSummary();

    if (!hasLockState) {
      if (filledSlots.length) {
        tableLocks = slots.map(isFilledSlot);
        hasLockState = true;
      } else if (summaryCount > 0) {
        tableLocks = Array.from({ length: summaryCount }, function () {
          return true;
        });
        hasLockState = true;
      }

      return;
    }

    if (!filledSlots.length) {
      if (summaryCount > 0) {
        return;
      }

      tableLocks = [];
      hasLockState = false;
      return;
    }

    // Do not unlock tables just because later placeholder slots are empty.
    // A single-table unlock is handled by the remove button's slot index.
  }

  function currentStepHasSelection() {
    syncLocksWithSelectedSlots();

    var currentStepIndex = getCurrentStepIndex();

    if (hasLockState) {
      return Boolean(tableLocks[currentStepIndex]);
    }

    var slots = getVisibleSelectedSlots();
    var currentSlot = slots[currentStepIndex];

    if (currentSlot) {
      return isFilledSlot(currentSlot);
    }

    return false;
  }

  function isAddedAction(element) {
    var text = element && element.textContent ? element.textContent.trim().toLowerCase() : '';
    var className = element && element.className ? String(element.className) : '';

    return text === 'added' || /button_plus_selected|custom_class_btn_selected/.test(className);
  }

  function getActionText(element) {
    return element && element.textContent ? element.textContent.trim().toLowerCase() : '';
  }

  function getActionLabel(element) {
    if (!element) {
      return '';
    }

    return [
      element.getAttribute('aria-label'),
      element.getAttribute('title'),
      element.getAttribute('data-testid'),
      element.getAttribute('data-test-id'),
    ]
      .filter(Boolean)
      .join(' ')
      .trim()
      .toLowerCase();
  }

  function isClearAction(element) {
    if (!element) {
      return false;
    }

    var className = element.className ? String(element.className) : '';
    var text = getActionText(element).replace(/[()]/g, '').trim();
    var label = getActionLabel(element);

    return /mobileClear|clear/i.test(className) || text === 'clear' || /clear/.test(label);
  }

  function isDeleteAction(element) {
    if (!element) {
      return false;
    }

    var className = element.className ? String(element.className) : '';
    var text = getActionText(element);
    var label = getActionLabel(element);

    return (
      /icon_remove_product/i.test(className) ||
      (/summary_btn_edit/i.test(className) && /delete|remove/.test(text + ' ' + label)) ||
      /delete|remove/.test(text) ||
      /delete|remove/.test(label) ||
      text === 'x' ||
      text.charCodeAt(0) === 215
    );
  }

  function isAddAction(element) {
    var action = element && element.closest(SELECTORS.addButton);

    if (!action || !isVisible(action)) {
      return null;
    }

    var text = getActionText(action);
    var className = action.className ? String(action.className) : '';
    var isAddButtonClass = /addToBoxButton-module__(button_atc|button_plus)/.test(className);
    var isMobileAddButtonClass = /productContent-module__(add_quantity_product_btn|product_button)/.test(className);
    var isAddButtonText = /add to box|choose options|add another/.test(text);

    if (!isAddButtonClass && !isMobileAddButtonClass && !isAddButtonText) {
      return null;
    }

    if (/added|edit options|view|out of stock|unavailable/.test(text)) {
      return null;
    }

    return action;
  }

  function shouldLockAddAction(action) {
    var text = getActionText(action);
    var className = String(action.className || '');

    return (
      /add to box|add another/.test(text) ||
      /addToBoxButton-module__button_plus/.test(className) ||
      /productContent-module__(add_quantity_product_btn|product_button)/.test(className)
    );
  }

  function resetAddedButton(button) {
    button.classList.remove(DISABLED_CLASS);
    button.removeAttribute('aria-disabled');
    button.removeAttribute('title');

    Array.from(button.classList).forEach(function (className) {
      if (/button_plus_selected|custom_class_btn_selected/.test(className)) {
        button.classList.remove(className);
      }
    });

    button.querySelectorAll('*').forEach(function (child) {
      if (child.textContent && child.textContent.trim().toLowerCase() === 'added') {
        child.textContent = 'Add to box';
      }
    });

    if (button.textContent.trim().toLowerCase() === 'added') {
      button.textContent = 'Add to box';
    }
  }

  function syncAddedButtonStyles() {
    var currentStepIndex = getCurrentStepIndex();
    var shouldKeepOneAdded = Boolean(tableLocks[currentStepIndex]);
    var addedButtons = Array.from(document.querySelectorAll(SELECTORS.addButton)).filter(function (button) {
      return isVisible(button) && isAddedAction(button);
    });

    addedButtons.forEach(function (button) {
      if (shouldKeepOneAdded && button === addedButtons[0]) {
        return;
      }

      resetAddedButton(button);
    });
  }

  function blockEvent(event) {
    var action = isAddAction(event.target);

    if (!action) {
      return;
    }

    if (!currentStepHasSelection()) {
      if (event.type === 'click' && shouldLockAddAction(action)) {
        tableLocks[getCurrentStepIndex()] = true;
        hasLockState = true;
      }
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    action.blur && action.blur();
  }

  function blockKeyboardEvent(event) {
    if (event.key !== 'Enter' && event.key !== ' ') {
      return;
    }

    blockEvent(event);
  }

  function getSelectedSlotIndex(element) {
    var slot = element && element.closest(SELECTORS.selectedSlot);

    if (!slot) {
      return -1;
    }

    return getVisibleSelectedSlots().indexOf(slot);
  }

  function openStep(stepIndex) {
    if (stepIndex < 0) {
      return;
    }

    var stepTargets = Array.from(document.querySelectorAll(SELECTORS.stepClickTarget)).filter(isVisible);
    var target =
      stepTargets.find(function (stepTarget) {
        var stepNumber = parseStepNumber(stepTarget);
        var iconNumber = parseStepNumber(stepTarget.querySelector(SELECTORS.stepIcon));

        return stepNumber === stepIndex + 1 || iconNumber === stepIndex + 1;
      }) || stepTargets[stepIndex];

    if (target) {
      target.click();
    }
  }

  function clearAllLocks() {
    tableLocks = [];
    hasLockState = false;
  }

  function handleRemoveSelection(event) {
    var clearButton = event.target && event.target.closest(SELECTORS.clearButton + ', button, [role="button"]');

    if (clearButton && isClearAction(clearButton)) {
      clearAllLocks();
      window.setTimeout(function () {
        syncAddedButtonStyles();
        scheduleUpdate();
      }, 120);
      return;
    }

    var removeButton = event.target && event.target.closest(SELECTORS.removeButton + ', button, [role="button"]');

    if (!removeButton || !removeButton.closest(SELECTORS.selectedSlot) || !isDeleteAction(removeButton)) {
      return;
    }

    var removedSlotIndex = getSelectedSlotIndex(removeButton);

    if (removedSlotIndex < 0) {
      return;
    }

    tableLocks[removedSlotIndex] = false;
    hasLockState = true;

    window.setTimeout(function () {
      openStep(removedSlotIndex);
      syncLocksWithSelectedSlots();
      syncAddedButtonStyles();
      scheduleUpdate();
    }, 120);
  }

  function updateDisabledState() {
    syncLocksWithSelectedSlots();
    syncAddedButtonStyles();

    var shouldDisable = currentStepHasSelection();

    Array.from(document.querySelectorAll(SELECTORS.addButton)).forEach(function (button) {
      if (!isAddAction(button)) {
        button.classList.remove(DISABLED_CLASS);
        button.removeAttribute('aria-disabled');
        button.removeAttribute('title');
        return;
      }

      button.classList.toggle(DISABLED_CLASS, shouldDisable);
      if (shouldDisable) {
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('title', WARNING_TEXT);
      } else {
        button.removeAttribute('aria-disabled');
        button.removeAttribute('title');
      }
    });
  }

  function scheduleUpdate() {
    window.clearTimeout(mutationTimer);
    mutationTimer = window.setTimeout(function () {
      updateDisabledState();
    }, 80);
  }

  function handleTableClick(event) {
    if (!event.target.closest(SELECTORS.stepClickTarget)) {
      return;
    }

    window.setTimeout(function () {
      syncLocksWithSelectedSlots();
      syncAddedButtonStyles();
      updateDisabledState();
    }, 120);
  }

  function injectStyle() {
    if (document.getElementById('box-builder-limit-style')) {
      return;
    }

    var style = document.createElement('style');
    style.id = 'box-builder-limit-style';
    style.textContent =
      '.' +
      DISABLED_CLASS +
      '{opacity:.45!important;cursor:not-allowed!important;pointer-events:auto!important;}';
    document.head.appendChild(style);
  }

  function exposeDebugState() {
    window.__boxBuilderLimitDebug = function () {
      return {
        currentStepIndex: getCurrentStepIndex(),
        selectedSlotCount: getVisibleSelectedSlots().length,
        filledSelectedSlotCount: getVisibleSelectedSlots().filter(isFilledSlot).length,
        selectedItemCountFromSummary: getSelectedItemCountFromSummary(),
        tableLocks: tableLocks.slice(),
        hasLockState: hasLockState,
      };
    };
  }

  function init() {
    injectStyle();
    exposeDebugState();
    document.addEventListener('mousedown', handleRemoveSelection, true);
    document.addEventListener('touchstart', handleRemoveSelection, true);
    document.addEventListener('click', handleRemoveSelection, true);
    document.addEventListener('click', handleTableClick, true);
    document.addEventListener('click', blockEvent, true);
    document.addEventListener('mousedown', blockEvent, true);
    document.addEventListener('touchstart', blockEvent, true);
    document.addEventListener('keydown', blockKeyboardEvent, true);

    new MutationObserver(scheduleUpdate).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'disabled', 'aria-disabled'],
    });

    updateDisabledState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
